import React from 'react'

import { Chip, Icon, formatPhoneNumber } from '~components/internal'

import './FromToPhoneChip.scss'

export const FromToPhoneChip: React.FC<{
  fromNumber: string
  toNumber: string
  icon: React.ReactElement
}> = ({ fromNumber, toNumber, icon }) => (
  <Chip
    icon={icon}
    label={
      <span className='from-to-phone-chip__label'>
        {formatPhoneNumber(fromNumber)}
        <Icon name='ArrowRightAltIcon' />
        {formatPhoneNumber(toNumber)}
      </span>
    }
    color='neutral'
    size='small'
  />
)
